export const GlobalConfig = Object.freeze({
  ADMIN_URL: 'https://crm.9qq.org/',
  API_URL: '/qumalaq'
});
